<template>
  <div class="upload-btn-div">
    <span class="upload-btn-container">
      <div class="pp">
        <img src="/images/photo-camera.png" alt />
      </div>
      <file-upload
        class="btn btn-primary"
        :post-action="s3Url"
        :accept="accepted"
        :extensions="extensions"
        :headers="headers"
        :size="1024 * 1024 * 10"
        :data="{
          role,
          module,
          created_for,
          certificate_type,
          remarks,
          deleteable,
          tentative_date,
          patient_name
        }"
        :maximum="maximum"
        v-model="files"
        ref="upload"
        :input-id="refName"
        @input-file="inputFile"
        @input-filter="inputFilter"
        :multiple="multiple"
        :drop="drop"
        :disabled="disabled"
      >
        <span class="white--text" v-text="label" v-if="!drop"></span>
        <div class="white--text" v-if="drop" v-html="label"></div>
      </file-upload>
    </span>
    <span
      class="badged-uploads"
      v-if="previousImage && previousImage.length > 0"
    >
      <div class="d-align">
        <span class="badge primary">{{ previousImage.length }}</span>
        <!-- <a
          @click="imagePreviewPanel = true"
        >view {{ previousImage.length == 1 ? "image" : "images" }}</a>-->
        <a @click="imagePreviewPanel = true" class="pl-1">view</a>
      </div>
      <div class="cross-svg">
         <crossSVG @click="removeFile()" />
      </div>
    
    </span>
    <span class="badged-uploads d-flex" v-if="pdfSrc && pdfSrc.length">
      <div class="d-align">
        <span class="badge primary">{{ pdfSrc.length }}</span>
        <!-- <a @click="galleryModal = true">view {{ pdfSrc.length == 1 ? "pdf" : "pdfs" }}</a> -->
        <a @click="galleryModal = true">view</a>
      </div>
      <div class="v-btn__content cursor ml-2 mr-1">
            <button type="button" aria-label="Close" @click="removeFile()" class="close">×</button>
          </div>
    </span>

    <!-- <light-box :images="previousImage" ref="lightbox" :show-light-box="false"></light-box> -->

    <v-dialog v-model="galleryModal" width="900" content-class="v-dialog-lg">
      <v-card class="min-height" id="pharmacyCard">
        <nav
          class="v-toolbar theme--dark primary"
          data-booted="true"
          style="margin-top: 0px; padding-right: 0px; padding-left: 0px; transform: translateY(0px);"
        >
          <div class="v-toolbar__content" style="height: 40px;">
            <div class="v-toolbar__title">PDF</div>
            <div class="spacer"></div>
            <button type="button" @click="galleryModal = false">
              <v-icon style="color:white">close</v-icon>
            </button>
          </div>
        </nav>
        <v-card-text style>
          <span @click="prePdf" v-if="pdfSrc[0] != currentPdf">
            <i class="fas fa-fast-backward"></i>
          </span>
          <span @click="currentPage = currentPage - 1" v-if="currentPage > 1">
            <i class="fas fa-backward"></i>
          </span>
          <!-- <pdf
            v-if="serverUrl"
            :src="currentPdf"
            @num-pages="pageCount = $event"
            :page="currentPage"
            @page-loaded="currentPage = $event"
            style="display: inline-block; width: 50%"
          ></pdf>-->
          <embed :src="currentPdf" width="100%" height="800px" />
          <span
            @click="currentPage = currentPage + 1"
            v-if="currentPage < pageCount"
          >
            <i class="fas fa-forward"></i>
          </span>
          <span
            @click="nextPdf"
            v-if="pdfSrc && pdfSrc[pdfSrc.length - 1] != currentPdf"
          >
            <i class="fas fa-fast-forward"></i>
          </span>
        </v-card-text>
        <v-card-actions>
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12 flex-end">
                <v-btn class="btn btn-red-outline" @click="galleryModal = false"
                  >Close</v-btn
                >
                <!-- <v-btn class="btn btn-primary" type="button">Save</v-btn> -->
              </div>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imagePreviewPanel" width="680" persistent scrollable>
      <image-preview
        @update="updateImages"
        @delete="removeFile"
        :list="previousImage"
        @close="imagePreviewPanel = false"
      ></image-preview>
    </v-dialog>
    <!-- <v-dialog
      v-if="edit"
      v-model="edit"
      width="680"
      persistent
      scrollable
      content-class="v-dialog-lg"
    >
      <image-crop
        :file="files[0]"
        :edit="edit"
        @crop="cropImage"
        @cancel="cancelCrop"
        @close="edit = false"
      ></image-crop>
    </v-dialog> -->
    <!-- <span v-for="(file, id) in previousImage" :key="id"> -->
    <!-- <h1>In server</h1> -->
    <!-- <span class="txt-ellipp martop-2p">{{ file.name }}</span>
      <span>
        <img
          @click="removePreviousFile(index)"
          src="/images/error.png"
          style="width: 20px;margin: 7px;opacity: 0.6;cursor:pointer"
        />
      </span>
    </span>-->
  </div>
</template>

<style lang="scss">
.example-simple label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}
.upload-btn-div {
  border: 1px solid #f1f1f1 !important;
  display: flex;
  position: relative !important;
  padding: 8px 5px !important;
  border-radius: 5px !important;
  align-items: center !important;
  height: 42px;
  right: 0;

  .upload-btn-container {
    height: unset !important;
  }

  .btn {
    background-color: #0285c0 !important;
    color: gray !important;
    border-color: gainsboro !important;
    box-shadow: unset !important;
    padding: 3px 10px !important;
    height: auto;
  }

  .txt-ellipp {
    margin-top: 0 !important;
    margin-left: 10px !important;
  }

  img {
    // opacity: 0.6 !important;
    vertical-align: sub !important;
    margin: 0 !important;
  }

  .pp {
    position: absolute !important;
    min-width: 40px !important;
    right: 0 !important;
  }
}

.v-dialog {
  .txt-ellipp {
    width: calc(100% - 4.5vw);
  }

  .layout {
    .txt-ellipp {
      width: calc(100% - 7vw);
    }
  }
}

.full-txt {
  .txt-ellipp {
    width: calc(100% - 0vw) !important;
    float: unset !important;
  }
}
</style>

<script>
// import imageCrop from "@/components/general/upload/cropImage";
import FileUpload from "vue-upload-component";
import config from "@/config.js";
import cloneDeep from "lodash/cloneDeep";
import LightBox from "vue-image-lightbox";
// import pdf from "vue-pdf";
import ImagePreview from "@/components/modals/imagePreview.vue";
export default {
  props: [
    "deleteable",
    "media",
    "label",
    "multiple",
    "drop",
    "module",
    "maximum",
    "created_for",
    "role",
    "refName",
    "uploadFileToServer",
    "src",
    "accept",
    "disabled",
    "certificate_type",
    "remarks",
    "tentative_date",
    "patient_name",
    "isPublicUpload",
    "isCropImage"
  ],
  components: {
    LightBox,
    // pdf,
    FileUpload,
    // imageCrop,
    ImagePreview
  },
  data() {
    return {
      imagePreviewPanel: false,
      galleryModal: false,
      currentPage: 1,
      pageCount: 0,
      pdfSrc: [],
      currentPdf: "",
      files: [],
      isImage: false,
      edit: false,
      fileurl: "",
      showPreview: false,
      dialog: false,
      previousImage: [],
      extensions: "jpg,jpeg,png,webp,pdf", // (FOR PDF FILE) https://stackoverflow.com/questions/12142536/how-to-make-input-type-file-should-accept-only-pdf-and-xls/12142616
      accepted:
        this.accept ||
        "image/png,image/jpg,image/jpeg,image/webp,application/pdf"
    };
  },
  computed: {
    isEditImage() {
      if (this.multiple) return false;
      else if (!this.isImage) return false;
      else if (this.isCropImage) return true;
      else return false;
    },
    serverUrl() {
      if (this.currentPdf && this.currentPdf.includes(".pdf")) {
        return true;
      }
      return false;
    },
    s3Url() {
      if (this.isPublicUpload) {
        return `${config.BASE_URL}api/v2/admin/public/blog/uploadFileS3`;
      }
      return `${config.BASE_URL}api/v2/admin/uploadFileS3`;
    },
    headers() {
      return {
        Authorization: `JWT ${this.$store.state.user.token}`
      };
    }
  },
  mounted() {
    if (this.src != undefined && this.src != "") {
      if (typeof this.src == "string") {
        if (
          this.src.includes(".pdf") ||
          (this.media && this.media.includes("pdf"))
        ) {
          this.pdfSrc = [this.src];
          this.currentPdf = this.src;
          console.log("currentPdf", this.currentPdf);
        } else {
          this.previousImage = [
            {
              src: this.src,
              thumb: this.src
            }
          ];
        }
      } else {
        this.previousImage = [];
        this.pdfSrc = [];

        this.src.map(img => {
          if (img.includes(".pdf")) {
            this.pdfSrc.push(img);
            if (!this.currentPdf) {
              this.currentPdf = img;
            }
          } else {
            let obj = {
              src: img,
              thumb: img
            };
            this.previousImage.push(obj);
          }
        });
      }
    } else {
      this.previousImage = [];
    }
  },
  watch: {
    uploadFileToServer: {
      handler(newValue) {
        this.$refs.upload.active = newValue;
      },
      deep: true
    },
    src: {
      deep: true,
      handler(newValue) {
        console.log("newValue", newValue);
        this.resetUpload();
        if (newValue != undefined && newValue != "") {
          this.$emit("imageAdded", {});
          if (typeof this.src == "string") {
            if (
              this.src.includes(".pdf") ||
              (this.media && this.media.includes("pdf"))
            ) {
              this.pdfSrc = [this.src];
              this.currentPdf = this.src;
            } else {
              this.previousImage = [
                {
                  src: this.src,
                  thumb: this.src
                }
              ];
              this.pdfSrc = [];
            }
          } else {
            if (
              this.src.includes(".pdf") ||
              (this.media && this.media.includes("pdf"))
            ) {
              this.pdfSrc = this.src;
              this.currentPdf = this.src[0];
            } else {
              this.previousImage = [];
              this.pdfSrc = [];

              this.src.map(img => {
                if (img.includes(".pdf")) {
                  this.pdfSrc.push(img);
                  if (!this.currentPdf) {
                    this.currentPdf = img;
                  }
                } else {
                  let obj = {
                    src: img,
                    thumb: img
                  };
                  this.previousImage.push(obj);
                }
              });
            }
          }
        } else {
          this.previousImage = [];
        }
      }
    },
    accept: {
      handler(newValue) {
        this.accepted = "";
        this.$nextTick(() => {
          this.accepted = newValue;
        });
      }
    }
  },
  methods: {
    cancelCrop() {
      this.$refs.upload.clear();
      this.edit = false;
    },
    removeAllImages() {
      this.previousImage = [];
      this.files = [];
    },
    cropImage(oldFileId, obj) {
      this.$refs.upload.update(oldFileId, obj);
      this.edit = false;
      this.$refs.upload.active = this.uploadFileToServer;
      this.$emit("uploaded", this.files, this.$refs.upload.uploaded);
    },
    updateImages(images, removedImage) {
      this.previousImage = images;
      let index = this.files.findIndex(item => item.blob === removedImage);
      if (index > -1) {
        this.files.splice(index, 1);
      } else {
        this.$emit("removeImage", this.previousImage);
      }
    },
    resetUpload() {
      this.previousImage = [];
      this.pdfSrc = [];
      this.currentPdf = "";
    },
    prePdf() {
      let index = this.pdfSrc.indexOf(this.currentPdf);
      this.currentPdf = this.pdfSrc[index - 1];
      this.currentPage = 1;
    },
    nextPdf() {
      let index = this.pdfSrc.indexOf(this.currentPdf);
      this.currentPdf = this.pdfSrc[index + 1];
      this.currentPage = 1;
    },
    removePreviousFile(index) {
      this.previousImage.splice(index, 1);
      this.$emit("uploaded", this.previousImage);
    },
    removeFile() {
      this.$emit("imageRemoved", this.refName);
      this.files = [];
      if (this.previousImage && this.previousImage.length) {
        for (let index = 0; index < this.previousImage.length; index++) {
          this.removeImage(index);
        }
      }
      this.previousImage = [];
      this.pdfSrc = [];
      this.$emit("uploaded", this.files);
    },
    removeImage(index) {
      let url = this.previousImage[index].src;
      url = url.split(
        `https://${config.S3_BUCKET}.s3.ap-south-1.amazonaws.com/`
      );
      if (url && url.length == 2) {
        // this.removeImagefromServer(url[1], index);
      }
    },
    removeImagefromServer(name, index) {
      let url = `${config.NEW_BASE_URL}api/s3DeleteFile/${name}`;
      this.$http.delete(url).then(response => {});
    },
    inputFilter(newFile, oldFile, prevent) {
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        //check file is image or not for crop image feature
        if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.isImage = false;
        } else this.isImage = true;
        // Create the 'blob' field for thumbnail preview
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // if (URL && URL.createObjectURL && newFile.type.includes("image")) {
        //   newFile.blob = URL.createObjectURL(newFile.file);
        // }
        if (!this.isEditImage)
          this.$refs.upload.active = this.uploadFileToServer;
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.$nextTick(function() {
          this.edit = this.isEditImage;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
      if (typeof newFile != "undefined") {
        // doc https://github.com/lian-yue/vue-upload-component
        // this.$refs.upload.active = true;
        if (this.$refs.upload.uploaded) {
          let fileUrls = [];
          let fileName = [];
          let fileSize = this.files[0] && this.files[0]['size'] ? this.files[0]['size'] : 0
          let pdfFileName = this.files[0] && this.files[0]['name'] ? this.files[0]['name'] : ''
          this.files.map(file => {
            if (file.response.status) {
              //handling condition if we are setting image from DB
              fileUrls.push(file.response.file_url);
              fileName.push(file.response.data);
            } else {
              this.$swal("Upload failed");
            }
          });
          // After Files are Uploaded, return File URLs
          this.$emit(
            "uploaded",
            fileUrls,
            this.$refs.upload.uploaded,
            fileName,
            fileSize,
            pdfFileName
          );
          this.$refs.upload.clear();
        } else if (!this.isEditImage) {
          // When Files are Only selected and Not Uploaded
          this.$emit("uploaded", this.files, this.$refs.upload.uploaded);
        }

        // if (newFile.response.status && newFile.success) {
        //   this.fileurl = newFile.response.file_url;
        // } else if (!newFile.response.status && newFile.success) {
        //   this.$emit("error", "File upload failed");
        // }
      }
    }
  }
};
</script>
